export enum InvoiceStatus {
  Paid = "paid",
  Failed = "failed",
  Refunded = "refunded",
  CreditNote = "credit_note",
  Unknown = "unknown",
}
